var exports = {
  "mB": "xa15a2ab7--51c68d--name_wrapper",
  "UU": "xa15a2ab7--51c68d--name",
};

module.exports = exports;
